import { Typography } from "@mui/material";
import type { ReactNode } from "react";

import * as sx from "./welcome-message.sx";

// Presentational empty-state shell shared by the Catalyst modes (knowledge/model
// assistant and the agent). Callers supply their own title/body copy; `children`
// renders below the body (e.g. the agent picker) and `align="top"` lets that
// taller content scroll instead of being vertically centered.
export function WelcomeMessage({
  align = "center",
  body,
  children,
  title,
}: {
  align?: "center" | "top";
  body: ReactNode;
  children?: ReactNode;
  title: ReactNode;
}) {
  return (
    <sx.Container align={align}>
      <sx.CatalystIcon />
      <Typography variant="h2">{title}</Typography>
      <Typography variant="body1">{body}</Typography>
      {children}
    </sx.Container>
  );
}
